<div class="gridContainer">
	<!--STATION LIST-->
	<sim-list [floatingLabel]="true" icon="fa-cubes" label="EXAM_SESSION_DIALOG_STEP2_STATION_LIST">
		<ng-container actions>
			<sim-new-list-item
				(add)="addExamStation()"
				[disabled]="disableAddStation()"
				buttonLabel="BUTTON_ADD"
				primaryLabel="CREATE_SESSION_DIALOG_NEW_STATION"
			/>
		</ng-container>
		@for (station of displayStations(); track station.id) {
			@let preventSelection = currentStationIndex() !== $index && step2Form.invalid;
			<sim-list-item
				#listItem
				(onClick)="currentStationIndex.set($index)"
				[invalid]="step2Form.at($index).invalid"
				[preventSelection]="preventSelection"
				[primaryLabel]="station.scenarioName ?? T.CREATE_SESSION_DIALOG_STATION_LIST_ITEM_EMPTY | translate"
				[secondaryLabel]="station.trainingRoomName"
				[selected]="currentStationIndex() === $index"
				[tooltip]="listItem.preventSelection() ? (T.ERROR_STATION_FORM_INVALID | translate) : null"
				id="stationCard-{{ $index }}"
				indicator="{{ $index + 1 }}"
			>
				<ng-container actions>
					<button
						(click)="removeExamStation(station.id, $index)"
						[disabled]="displayStations().length <= 1 || preventSelection"
						color="warn"
						mat-icon-button
						type="button"
					>
						<mat-icon fontIcon="fa-trash-alt" fontSet="fad" />
					</button>
				</ng-container>
			</sim-list-item>
		}
	</sim-list>

	<mat-divider vertical />

	<!--STATION FORM-->
	@if (isReady) {
		<sim-labelled-container
			[class.visible]="areFormsLoaded()"
			class="stationConfig"
			icon="fa-cube"
			label="EXAM_SESSION_DIALOG_STEP2_EXAM_STATION_CONFIG"
		>
			<sim-chip-autocomplete
				#scenarioField
				(onLoad)="onFormLoad(scenarioField)"
				[dataType]="FetchDataType.Scenario"
				[formCtrl]="stationForm().controls.scenario"
				[labelToken]="T.CREATE_SESSION_DIALOG_SCENARIO_SELECTION_LABEL"
			>
				<mat-icon fontIcon="fa-ballot-check" fontSet="fa" labelPrefix />
			</sim-chip-autocomplete>
			<sim-chip-autocomplete
				#roomField
				(onLoad)="onFormLoad(roomField)"
				[dataType]="FetchDataType.TrainingRoom"
				[excludeIds]="excludeRoomIds()"
				[formCtrl]="stationForm().controls.trainingRoom"
				[labelToken]="T.CREATE_SESSION_DIALOG_TRAINING_ROOM_LABEL"
			>
				<mat-icon fontIcon="fa-th" fontSet="fa" labelPrefix />
			</sim-chip-autocomplete>
			<sim-chip-autocomplete
				#examinerField
				(onLoad)="onFormLoad(examinerField)"
				[dataType]="FetchDataType.SimUser"
				[excludeIds]="excludeExaminerIds()"
				[formCtrl]="stationForm().controls.examiner"
				[labelToken]="T.CREATE_SESSION_DIALOG_EXAMINER_LABEL"
			>
				<mat-icon fontIcon="fa-user-md" fontSet="fa" labelPrefix />
			</sim-chip-autocomplete>
			<sim-chip-autocomplete
				#spField
				(onLoad)="onFormLoad(spField)"
				[dataType]="FetchDataType.SimUser"
				[excludeIds]="excludeUserIds()"
				[formCtrl]="stationForm().controls.standardizedPatient"
				[labelToken]="T.CREATE_SESSION_DIALOG_SPS_LABEL"
			>
				<mat-icon fontIcon="fa-user-injured" fontSet="fa" labelPrefix />
			</sim-chip-autocomplete>
		</sim-labelled-container>

		<sim-labelled-container [class.visible]="areFormsLoaded()" icon="fa-ballot-check" label="LABEL_ASSESSMENTS">
			<mat-accordion [hidden]="!areFormsLoaded()" displayMode="flat">
				@for (examPhase of examPhases(); track examPhase) {
					<mat-expansion-panel [expanded]="$first">
						<mat-expansion-panel-header>
							<mat-panel-title>
								{{ examPhase | enumLabel: EnumLabel.SessionPhase }}
							</mat-panel-title>
						</mat-expansion-panel-header>
						<!--EXAMINER ASSESSMENT-->
						<sim-chip-autocomplete
							*ngVar="stationForm().controls.assessments.get(SessionPhaseType[examPhase]) as assessmentCtrl"
							[dataType]="FetchDataType.Assessment"
							[formCtrl]="$any(assessmentCtrl.get('examiner'))"
							[labelToken]="T.PARTICIPANT_TYPE_EXAMINER"
						>
							<mat-icon fontIcon="fa-user-md" fontSet="fa" labelPrefix />
						</sim-chip-autocomplete>

						<!--STUDENT ASSESSMENT-->
						<sim-chip-autocomplete
							*ngVar="stationForm().controls.assessments.get(SessionPhaseType[examPhase]) as assessmentCtrl"
							[dataType]="FetchDataType.Assessment"
							[formCtrl]="$any(assessmentCtrl.get('student'))"
							[labelToken]="T.PARTICIPANT_TYPE_STUDENT"
						>
							<mat-icon fontIcon="fa-user-graduate" fontSet="fa" labelPrefix />
						</sim-chip-autocomplete>

						<!--SP ASSESSMENT-->
						<sim-chip-autocomplete
							*ngVar="stationForm().controls.assessments.get(SessionPhaseType[examPhase]) as assessmentCtrl"
							[dataType]="FetchDataType.Assessment"
							[formCtrl]="$any(assessmentCtrl.get('standardizedPatient'))"
							[labelToken]="T.PARTICIPANT_TYPE_STANDARDIZED_PATIENT"
						>
							<mat-icon fontIcon="fa-user-injured" fontSet="fa" labelPrefix />
						</sim-chip-autocomplete>
					</mat-expansion-panel>
				}
			</mat-accordion>
		</sim-labelled-container>
		<section class="stationConfig">
			<sim-component-loading-container [isLoading]="!areFormsLoaded()" [showBackDrop]="true" loadingIcon="fad fa-cube" />
		</section>
	}
</div>
